module.exports = __webpack_public_path__ + "img/hq-2026.90e373d2.jpg";